import { render, staticRenderFns } from "./noRateProduct2.vue?vue&type=template&id=41171988&scoped=true"
import script from "./noRateProduct2.vue?vue&type=script&lang=js"
export * from "./noRateProduct2.vue?vue&type=script&lang=js"
import style0 from "./noRateProduct2.vue?vue&type=style&index=0&id=41171988&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41171988",
  null
  
)

export default component.exports